import { createTheme, adaptV4Theme } from '@mui/material/styles';

// noinspection JSDeprecatedSymbols
const theme = createTheme(adaptV4Theme({
	palette: {
		primary: {
			main: '#713D90',
			dark: '#5A2275',
			light: '#B383CA',
		},
		secondary: {
			main: '#009FDA',
			dark: '#006F98',
			light: '#66C5E9',
		},
		error: {
			main: '#E53935',
			dark: '#9D392B',
			light: '#ED978A',
		},
		chip: {
			main: '#CDAEDD',
			dark: '#BA68C8',
			light: '#F3E5F5',
			contrastText: '#000'
		},
		background: {
			default: '#F2F1F0'
		}
	},
	overrides: {
		MuiFilledInput: {
			root: {
				"&$disabled": {
					backgroundColor: 'transparent',
					color: 'black',
					border: 0
				}
			},
			underline: {
				"&$disabled": {
					'&:before': {
						border: 0
					}
				}
			}
		},
		MuiTypography:{
			h6: {
				fontWeight: 'bold'
			}
		},
		MuiTableCell: {
			head: {
				fontWeight: 'bold'
			}
		},

		MuiButton: {
			outlined: {
				'& $label': {
					fontWeight: 'bold'
				}
			}
		},

		MuiSvgIcon: {
			root: {
				verticalAlign: 'middle',
			},
		},
		MuiFormControl: {
			marginNormal: {
				marginTop: 0,
			},
			marginDense: {
				marginTop: 0,
			}
		},

		MuiFormControlLabel: {
			labelPlacementStart: {
				marginLeft: 0,
				marginRight: 0,
				justifyContent: 'flex-end',

				'& .MuiFormControl-root': {
					marginLeft: 16,
				},
			},
		},
	},

	props: {
		MuiFormControl: {
			margin: 'normal',
		},
	},
}));

export default theme;